import type { V2WorkflowStagePayload } from '@/store/types'
import { StageType } from '@/store/types'

export const isWithinConsensus = (stages: V2WorkflowStagePayload[] = [], stageId = ''): boolean => {
  if (!stageId) {
    return false
  }

  return stages.some((stage) => {
    if (stage.type !== StageType.ConsensusEntrypoint) {
      return false
    }

    return [stage.id, stage.config.test_stage_id, ...stage.config.parallel_stage_ids].includes(
      stageId,
    )
  })
}

export const isWithinParallelBlind = (
  stages: V2WorkflowStagePayload[] = [],
  stageId?: string,
): boolean => {
  if (!stageId) {
    return false
  }

  return stages.some((stage) => {
    if (stage.type !== StageType.ParallelBlind) {
      return false
    }

    return stage.config.parallel_stages.some(({ stage_id }) => stage_id === stageId)
  })
}

export const getConsensusHiddenStagesIds = (stages: V2WorkflowStagePayload[] = []): string[] => {
  const hiddenStageIds: string[] = []

  for (const stage of stages) {
    if (stage.type !== StageType.ConsensusEntrypoint) {
      continue
    }

    hiddenStageIds.push(stage.config.test_stage_id, ...stage.config.parallel_stage_ids)
  }

  return hiddenStageIds
}

export const dropConsensusInternalStages = (
  stages: V2WorkflowStagePayload[],
): V2WorkflowStagePayload[] => {
  const subStagesIds = new Set(getConsensusHiddenStagesIds(stages))
  return stages.filter(({ id }) => !subStagesIds.has(id))
}
